export default "__VITE_PUBLIC_ASSET__da20e64d__"